import type { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { env } from '../environment/env'

declare global {
  interface Window {
    newrelic: BrowserAgent | undefined
  }
}

function getNewRelicAgent(): BrowserAgent | undefined {
  return window.newrelic
}

export interface Logger {
  logError: (error: Error) => void
  logInfo: (message: string) => void
  logDebug: (message: string, ...optionParams: unknown[]) => void
}

export const logger: Logger = {
  logError(error: Error) {
    try {
      const newRelicAgent = getNewRelicAgent()
      if (newRelicAgent && typeof newRelicAgent.noticeError === 'function') {
        newRelicAgent.noticeError(error)
      }
      else {
        // Fallback to console error if New Relic is not available
        // New Relic also logs to console so no need to log ourselves
        console.error(error)
      }
    }
    // eslint-disable-next-line unused-imports/no-unused-vars
    catch (e) {}
  },
  logInfo(message: string) {
    try {
      const newRelicAgent = getNewRelicAgent()
      if (newRelicAgent && typeof newRelicAgent.log === 'function') {
        newRelicAgent.log(message)
      }
      // eslint-disable-next-line no-console
      console.info(message)
    }
    // eslint-disable-next-line unused-imports/no-unused-vars
    catch (e) {}
  },
  logDebug(message: string, ...optionParams: unknown[]) {
    if (env.CONSOLE_DEBUG_ENABLED === true) {
      if (optionParams.length > 0) {
        // eslint-disable-next-line no-console
        console.debug(message, ...(optionParams as []))
      }
      else {
        // eslint-disable-next-line no-console
        console.debug(message)
      }
    }
  },
}
